<template>
  <div v-show="isLogin">

    <div class="row mb-2">
      <div class="col-md-6 text-left">
        <h3 class="panel-title">ข้อมูลผลการยืนยันเห็ดพิษ</h3>
      </div>
      <div class="col-md-6" align="right">
        <input type="button" class="btn btn-success" @click="openModel" value="บันทึกผลยืนยัน" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        &nbsp;
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <table class="table table-bordered">
          <thead>
            <tr>
              <td>ลำดับ</td>
              <td>ข้อมูลเห็ด</td>
              <td>ผลวิเคราะห์</td>
              <td>ข้อมูลพื้นที่</td>
              <td>แจ้งเตือน</td>
            </tr>
          </thead>
          <tbody>
           <tr v-if="mushroom_analysis.length===0" >
             <td colspan="5" class="text-center">ไม่พบข้อมูล</td>
           </tr>
           <tr v-else v-for="(mushroom, index) in mushroom_analysis">
             <td width="5%">{{index+1}}</td>
             <td class="text-left" width="25%">
               ชื่อเห็ดไทย: {{mushroom.mushroom_thai}} <br/>
               ชื่อวิทยาศาสตร์: {{mushroom.mushroom_science}} <br/>
               ประเภทเห็ด: {{}} <br/>
             </td>
             <td class="text-left" width="25%">
               ผลการตรวจวิเคราะห์: {{mushroom.analysis_result}} <br/>
               สรุปผลการตรวจวิเคราะห์: {{mushroom.summary_result}} <br/>
               ผู้ตรวจวิเคราะห์: {{mushroom.analyst}} <br/>
               หมายเหตุ: {{mushroom.note}} <br/>
             </td>
             <td class="text-left" width="25%">
               ข้อมูลพื้นที่พบเห็ด <br/>
               ต.{{mushroom.ttname}} อ.{{mushroom.amname}} จ.{{mushroom.prv_name_th}} <br/>
               ละติจูด: {{mushroom.latitude}}  <br/>
               ลองจิจูด: {{mushroom.longitude}}
             </td>
             <td width="10%">
               <button type="button" style="width: 80px;"
                       class="btn btn-sm btn-danger"
                       @click="deleteMushroomAnalysis(mushroom.id, mushroom.mushroom_thai)"
               >
                 ลบ
               </button>
               <br/>
               <button type="button"
                       style="width: 80px;margin-top: 8px;"
                       class="btn btn-sm btn-warning"
                       @click="gotoAlertToUser(mushroom.id)"
               >
                 แจ้งเตือน
               </button>
             </td>
           </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="isModelAdd">
      <transition name="model">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" @click="isModelAdd=false"><span aria-hidden="true">&times;</span></button>
                  <h4 class="modal-title">บันทึกผลยืนยัน</h4>
                </div>
                <div class="modal-body" style="overflow-y: auto;max-height: 500px;">

                  <div class="row">

                    <div class="form-group col-md-12">
                      <div class="text-left"><label><h5> ข้อมูลพื้นที่พบเห็ด </h5></label></div>
                    </div>

                    <div class="form-group col-md-4">
                      <div class="text-left"><label>จังหวัด</label></div>
                      <select class="form-control" v-model="pvcode">
                        <option value="">-- เลือกจังหวัด --</option>
                        <option v-if="provinces.length > 0" v-for="province in provinces" :value="province.pvcode">
                          {{province.prv_name_th}}
                        </option>
                      </select>
                    </div>

                    <div class="form-group col-md-4">
                      <div class="text-left"><label>อำเภอ</label></div>
                      <select class="form-control" v-model="amcode">
                        <option value="">-- เลือกอำเภอ --</option>
                        <option v-if="amphurs.length > 0" v-for="amphur in amphurs" :value="amphur.amcode">
                          {{amphur.amname}}
                        </option>
                      </select>
                    </div>

                    <div class="form-group col-md-4">
                      <div class="text-left"><label>ตำบล</label></div>
                      <select class="form-control" v-model="ttcode">
                        <option value="">-- เลือกตำบล --</option>
                        <option v-if="tumbons.length > 0" v-for="tumbon in tumbons" :value="tumbon.ttcode">
                          {{tumbon.ttname}}
                        </option>
                      </select>
                    </div>

                    <div class="form-group form-inline col-md-4">
                      <div class="text-left"><label>&nbsp;</label></div>
                      <input
                             type="checkbox" @change="latLngCheck = !latLngCheck"
                             :checked="latLngCheck"
                      /> ไม่สามารถระบุ ละติจูด ลองจิจูด ได้
                    </div>

                    <div class="form-group col-md-4">
                      <div class="text-left"><label>ละติจูด</label></div>
                      <input type="number" class="form-control" placeholder="ละติจูด"
                             v-model="latitude"
                             :disabled="latLngCheck"
                      />
                    </div>

                    <div class="form-group col-md-4">
                      <div class="text-left"><label>ลองจิจูด</label></div>
                      <input type="number" class="form-control" placeholder="ลองจิจูด"
                             v-model="longitude"
                             :disabled="latLngCheck"
                      />
                    </div>

                    <div class="col-md-12">
                      <hr/>
                    </div>

                  </div>

                  <div class="row">

                    <div class="form-group col-md-12">
                      <div class="text-left"><label><h5> ข้อมูลเห็ด </h5></label></div>
                    </div>

                    <div class="form-group col-md-6">
                      <div class="text-left"><label> ชื่อสามัญ/ชื่อท้องถิ่นของเห็ด </label></div>
                      <input type="text" class="form-control"
                             placeholder="ชื่อสามัญ/ชื่อท้องถิ่นของเห็ด"
                             v-model="mushroom_thai"
                      />
                    </div>

                    <div class="form-group col-md-6">
                      <div class="text-left"><label> ชื่อวิทยาศาสตร์</label></div>
                      <input type="text" class="form-control"
                             placeholder="ชื่อวิทยาศาสตร์"
                             v-model="mushroom_science"
                             name="mushroom_science"
                      />
                    </div>

                    <div class="form-group col-md-12">
                      <div class="text-left"><label> ประเภทเห็ด </label></div>
                      <select class="form-control"
                              name="mushroom_type"
                              v-model="mushroom_type"
                      >
                        <option value="unknown">ไม่ทราบ</option>
                        <option value="poison">เห็ดพิษ</option>
                        <option value="edible">เห็ดกินได้</option>
                      </select>
                    </div>

                    <div class="col-md-12">
                      <hr>
                    </div>

                  </div>

                  <div class="row">
                    <div class="form-group col-md-12">
                      <div class="text-left"><label><h5> ผลการวิเคราะห์ </h5></label></div>
                    </div>

                    <div class="form-group col-md-12">
                      <div class="text-left"><label>ผลการตรวจวิเคราะห์</label></div>
                      <input type="text" placeholder="ผลการตรวจวิเคราะห์"
                             class="form-control"
                             v-model="analysis_result" />
                    </div>

                    <div class="form-group col-md-6">
                      <div class="text-left"><label>สรุปผลการตรวจวิเคราะห์</label></div>
                      <select class="form-control"
                              name="summary_result"
                              v-model="summary_result" >
                        <option value="ไม่ระบุ">ไม่ระบุ</option>
                        <option value="พบสารพิษ">พบสารพิษ</option>
                        <option value="ไม่พบสารพิษ">ไม่พบสารพิษ</option>
                      </select>
                    </div>

                    <div class="form-group col-md-6">
                      <div class="text-left"><label>ผู้ตรวจวิเคราะห์</label></div>
                      <input type="text" placeholder="ผู้ตรวจวิเคราะห์"
                             class="form-control" v-model="analyst" />
                    </div>

                    <div class="form-group col-md-12">
                      <div class="text-left"><label>หมายเหตุ</label></div>
                      <input type="text" placeholder="หมายเหตุ"
                             class="form-control" v-model="note" />
                    </div>

                  </div>

                  <div align="center">
                    <!--<input type="hidden" v-model="hiddenId" />-->
                    <button type="button"
                            class="btn btn-success"
                            @click="submitAddData">
                       บันทึกข้อมูล
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  // import axios from 'axios'
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import { units } from '../units'

  export default {
    name: 'ConfirmAndAlert',
    data () {
      return {
        isModelAdd: false,
        provinces: [],
        amphurs: [],
        tumbons: [],
        pvcode: '',
        amcode: '',
        ttcode: '',
        latLngCheck: false,
        latitude: '',
        longitude: '',
        mushroom_thai: '',
        mushroom_science: '',
        mushroom_type: '',
        analysis_result: '',
        summary_result: '',
        analyst: '',
        note: '',
        mushroom_analysis: []
      }
    },
    created () {
      this.latLngCheck = false
      this.loadProvince()
      this.loadMushroomAnalysis()
    },
    computed: {
      ...mapGetters([
        'getBaseUrl',
        'getAuthen'
      ]),
      isLogin () {
        return this.getAuthen.token !== ''
      }
    },
    methods: {
      openModel: function () {
        this.isModelAdd = true
      },
      getMushroomTypeText: function (mushroomType) {
        return units.getMushroomTypeText(mushroomType)
      },
      loadProvince: function () {
        let url = this.getBaseUrl + '/province.php'
        axios.get(url).then(res => {
          let data = res.data
          this.provinces = data
        })
      },
      loadAmphur: function (provinceId) {
        let url = this.getBaseUrl + '/amphur.php?provinceId=' + provinceId
        axios.get(url).then(res => {
          let data = res.data
          this.amphurs = data
        })
      },
      loadTumbon: function (amcode) {
        let url = this.getBaseUrl + '/tumbon.php?amcode=' + amcode
        axios.get(url).then(res => {
          let data = res.data
          this.tumbons = data
        })
      },
      loadMushroomAnalysis: function () {
        let url = this.getBaseUrl + '/mushroom_analysis.php'
        axios.get(url).then(res => {
          let data = res.data
          this.mushroom_analysis = data
        })
      },
      submitAddData: function () {
        // let actionButton = this.actionButton
        // console.log('actionButton=', actionButton)
        // Vue.swal('Hello Vue world!!!')
        // this.$swal('Hello Vue world!!!')
        // alert('actionButton')
        // this.functionAlert('Hello', 'yessss')
        if (this.pvcode === '') {
          alert('กรุณาเลือกจังหวัด')
          return
        }

        if (this.amcode === '') {
          alert('กรุณาเลือกอำเภอ')
          return
        }

        if (this.ttcode === '') {
          alert('กรุณาเลือกตำบล')
          return
        }

        // console.log('this.latLngCheck=', this.latLngCheck, typeof this.latLngCheck)
        // console.log('this.latitude=', this.latitude)
        if (this.latLngCheck === false) {
          if (this.latitude === '0' && this.latitude !== '') {
            alert('กรุณากรอกละติจูด')
            return
          }
          if (this.longitude === '0' && this.longitude !== '') {
            alert('กรุณากรอกลองจิจูด')
            return
          }
        }

        if (this.mushroom_thai === '') {
          alert('กรุณากรอกชื่อสามัญ/ชื่อท้องถิ่นของเห็ด')
          return
        }
        if (this.analysis_result === '') {
          alert('กรุณากรอกผลการตรวจวิเคราะห์')
          return
        }
        if (this.analyst === '') {
          alert('กรุณากรอกผู้ตรวจวิเคราะห์')
          return
        }

        let hphId = this.getAuthen.hph_id
        let token = this.getAuthen.token
        /* let data = {
          hph_id: hphId,
          token: token,
          pvcode: this.pvcode,
          amcode: this.amcode,
          ttcode: this.ttcode,
          latitude: this.latitude,
          longitude: this.longitude,
          mushroom_thai: this.mushroom_thai,
          mushroom_science: this.mushroom_science,
          mushroom_type: this.mushroom_type,
          analysis_result: this.analysis_result,
          summary_result: this.summary_result,
          analyst: this.analyst,
          note: this.note
        } */

        const formData = new FormData()
        formData.append('hph_id', hphId)
        formData.append('token', token)
        formData.append('pvcode', this.pvcode)
        formData.append('amcode', this.amcode)
        formData.append('ttcode', this.ttcode)
        formData.append('latitude', this.latitude)
        formData.append('longitude', this.longitude)
        formData.append('mushroom_thai', this.mushroom_thai)
        formData.append('mushroom_science', this.mushroom_science)
        formData.append('mushroom_type', this.mushroom_type)
        formData.append('analysis_result', this.analysis_result)
        formData.append('summary_result', this.summary_result)
        formData.append('analyst', this.analyst)
        formData.append('note', this.note)

        let url = this.getBaseUrl + '/mushroom_analysis_save.php'
        // console.log(data)
        // console.log(formData)
        // console.log('url=', url)
        axios.post(url, formData).then(res => {
          // console.log(res.data)
          this.loadMushroomAnalysis()
          this.isModelAdd = false
        })
      },
      deleteMushroomAnalysis: function (id, mushroomName) {
        if (confirm('ต้องการลบผลวิเคราะห์: ' + mushroomName)) {
          let url = this.getBaseUrl + '/mushroom_analysis_delete.php'
          let hphId = this.getAuthen.hph_id
          let token = this.getAuthen.token
          const formData = new FormData()
          formData.append('hph_id', hphId)
          formData.append('token', token)
          formData.append('id', id)
          axios.post(url, formData).then(res => {
            if (res.data.result === 'success') {
              this.loadMushroomAnalysis()
            }
          })
        }
      },
      gotoAlertToUser (id) {
        this.$router.push({path: `/alerttouser/${id}`})
      }
    },
    watch: {
      pvcode: function (value, valueOld) {
        if (value !== '') {
          if (value !== valueOld) {
            this.amcode = ''
          }
          let provinceId = value
          this.loadAmphur(provinceId)
        } else {
          this.amphurs = []
          this.amcode = ''
        }
      },
      amcode: function (value, valueOld) {
        if (value !== valueOld) {
          this.ttcode = ''
        }
        this.loadTumbon(value)
      },
      latLngCheck: function (value) {
        if (value) {
          this.latitude = 0.0
          this.longitude = 0.0
        }
      }
    }
  }

</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  #confirm {
    display: none;
    background-color: #F3F5F6;
    color: #000000;
    border: 1px solid #aaa;
    position: fixed;
    width: 300px;
    height: 100px;
    left: 50%;
    margin-left: -100px;
    padding: 10px 20px 10px;
    box-sizing: border-box;
    text-align: center;
  }
  #confirm button {
    background-color: #FFFFFF;
    display: inline-block;
    border-radius: 12px;
    border: 4px solid #aaa;
    padding: 5px;
    text-align: center;
    width: 60px;
    cursor: pointer;
  }
  #confirm .message {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// ConfirmAndAlert.vue?55eaf8eb